<template>
  <div class="stry-cont">
    <div class="abt-container">
      <div class="header-cont">
        <span class="header text-capitalize">About {{ viewUser.display_name ? viewUser.display_name : "nodisplayname" }}</span>
      </div>
      <div class="abt-2-cont">
        <span v-if="viewUser.role === 'patient'" class="intro">
          <span class="name text-capitalize">{{ viewUser.display_name ? viewUser.display_name : "nodisplayname" }}</span> is living with
          {{ profileData && profileData["disease_type"] ? profileData["disease_type"] : currentCircle.condition_type }}
          <span v-if="profileData['diagnosis_date']"> since {{ getDiagnosedYear }}.</span>
          <!-- <span v-if="profileData['diagnosis_date']"> for the past {{ getDiagnosisDate }}.</span> -->
        </span>
        <span v-if="viewUser.role === 'caregiver' && profileData && profileData['diagnosis_date']" class="intro">
          <span v-if="profileData['dob']" class="name text-capitalize">{{ viewUser.display_name ? viewUser.display_name : "nodisplayname" }}</span>
          <!-- is taking care of a patient of {{ getDiagnosisDate }} living with a condition {{ profileData["disease_type"] }}. -->
          is taking care of a patient who is living with the condition {{ profileData["disease_type"] }} for about {{ getDiagnosisDate }}.
          <!-- is taking care of a patient of {{ getDOB }} years living with a condition {{ profileData["disease_type"] }}. -->
        </span>
        <div class="general-info">
          <div class="info-cont">
            <span class="name">Gender</span>
            <span v-if="profileData['gender']" class="intro text-capitalize">
              {{ profileData["gender"] }}
            </span>
            <span v-else class="dailog1">None added</span>
          </div>
          <div class="vertical-seperator"></div>
          <div class="info-cont">
            <span class="name">Current Work Situation</span>
            <span v-if="profileData['current_situation']" class="intro">{{ profileData["current_situation"] }}</span>
            <span v-else class="dailog1">None added</span>
          </div>
          <div class="vertical-seperator"></div>
          <div class="info-cont">
            <span class="name">Relationship Status</span>
            <span v-if="profileData['relationship_status']" class="intro text-capitalize">{{ profileData["relationship_status"] }}</span>
            <span v-else class="dailog1">None added</span>
          </div>
        </div>
        <div class="minibio">
          <span class="name">Mini Bio</span>
          <span class="bio" v-if="profileData['mini_bio'] || profileData['story']">
            {{ profileData["mini_bio"] || profileData["story"] }}
          </span>
          <div class="top" v-else>
            <span class="dailog">This user hasn’t added anything yet.</span>
          </div>
        </div>
      </div>

      <!-- symptoms -->

      <div id="firstloop" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
        <div v-if="cardKey === 'symptom'" class="symptoms">
          <div v-if="!cardValue" class="header-cont">
            <span class="header">Symptoms related to {{ currentCircle.condition_type }}</span>
          </div>
          <div v-if="profileData[cardKey].length > 0" class="symptomsgrid">
            <div v-for="(symptom, index) in profileData[cardKey]" :key="index" class="grid-item">
              <div class="info-cont">
                <span class="name">{{ symptom.display_name }}</span>
                <span
                  :style="{
                    color: getEffectivenessColor(symptom.effectiveness),
                    background: `${getEffectivenessColor(symptom.effectiveness)}25`,
                    padding: '2px 5px',
                    'min-width': '100px',
                    'border-radius': '5px',
                    display: 'flex',
                    'justify-content': 'center',
                  }"
                >
                  {{ getEffectiveness(symptom.effectiveness) }}
                </span>
              </div>
            </div>
          </div>
          <div v-else class="dailog">This user hasn’t added any symptoms yet.</div>
        </div>
      </div>

      <!-- other diagnosed condition -->

      <div id="2loop" v-for="(cardValue, cardKey, index) in cardKeys" :key="index" :style="{ width: '100%' }">
        <div v-if="cardKey === 'other_symptom'" class="symptoms">
          <div v-if="!cardValue" class="cont">
            <div class="header-cont">
              <span class="header">Other Diagnosed Conditions and Symptoms</span>
            </div>
            <span class="bio">(Conditions that have been diagnosed by a healthcare professional)</span>
          </div>
          <!-- <div class="top" v-if="profileData['other_symptom'].length > 0">
            <div v-for="(item, index) in otherPatientConditions" :key="index" class="other-condition">
              <div class="other-cond-header">
                <span v-if="item" class="header-cond">{{ item }}</span>
              </div>
              <div class="symp-cont">
                <span class="name">Symptoms:</span>
                <div v-for="(symptom, index) in profileData[cardKey]" :key="index" class="grid-cont">
                  <div v-if="symptom.circle_name === item" class="symptomsgrid">
                    <div>
                      <div class="grid-item">
                        <div class="info-cont">
                          <span class="name"> {{ symptom.display_name }}</span>
                          <span
                            :style="{
                              color: getEffectivenessColor(symptom.effectiveness),
                              background: `${getEffectivenessColor(symptom.effectiveness)}25`,
                              padding: '2px 5px',
                              'min-width': '100px',
                              'border-radius': '5px',
                              width: 'fit-content',
                              display: 'flex',
                              'justify-content': 'center',
                            }"
                          >
                            {{ getEffectiveness(symptom.effectiveness) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <SimpleLoader :name="'other diagnosed conditions'" v-if="otherCondnLoading" class="mx-auto" />

          <div class="top" v-if="otherConditionsList && otherConditionsList.length" :style="{ width: '100%' }">
            <div v-for="item in otherConditionsList" :key="item" class="other-condition">
              <div class="other-cond-header">
                <span v-if="item" class="header-cond">{{ item.othercondition_details.display_name || "" }}</span>
              </div>
              <div class="symp-cont" v-if="item.symptom && item.symptom.length">
                <span class="name">Symptoms:</span>
                <div class="symptomsgrid">
                  <div v-for="symptom in item.symptom" :key="symptom" class="grid-item">
                    <div class="info-cont">
                      <span class="name"> {{ symptom.symptom_details.display_name }}</span>
                      <span
                        class="rounded fw700 font12 d-flex px-2 py-1 justify-content-center"
                        :style="{ color: getEffectivenessColor(symptom.effectiveness), background: `${getEffectivenessColor(symptom.effectiveness)}25`, 'line-height': '14px', width: 'fit-content' }"
                      >
                        {{ getEffectiveness(symptom.effectiveness) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 w-100" v-for="eachTreatment in treatmentTypes" :key="eachTreatment">
                <div class="mb-3 d-flex justify-content-between">
                  <p class="mb-0 gray900 fw700 font16">{{ eachTreatment }}:</p>
                </div>
                <template v-if="item[getOCKeyName(eachTreatment)] && item[getOCKeyName(eachTreatment)].length">
                  <div class="p12 br8 d-flex gap10 flex-column mb-2" :style="{ border: '1px solid #E2E8F0' }" v-for="treatmentDetails in item[getOCKeyName(eachTreatment)]" :key="treatmentDetails.id">
                    <div class="d-flex align-items-center">
                      <div class="dot" :style="{ background: getEffectivenessColor(treatmentDetails.effectiveness) }"></div>
                      <p class="ml-1 mb-0 font16 fw700 gray900 flex-grow-1">{{ getTreamentDisplayName(eachTreatment, treatmentDetails) }}</p>
                    </div>

                    <div class="d-flex align-items-center" v-if="!['Activities', 'Nutrition'].includes(eachTreatment)">
                      <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
                      <div class="d-flex align-items-center flex-wrap gap8" v-if="treatmentDetails.side_effect && treatmentDetails.side_effect.length">
                        <div class="br8 py-1 px-2 d-flex" :style="{ border: '1px solid #e2e8f0' }" v-for="sideEffect in treatmentDetails.side_effect" :key="sideEffect">
                          <p class="mr-3 mb-0 gray900 font12">{{ sideEffect.display_name }}</p>
                          <p class=" mb-0 fw700 font12" :style="{ color: getEffectivenessColor(sideEffect.effectiveness) }">
                            {{ getEffectiveness(sideEffect.effectiveness) }}
                          </p>
                        </div>
                      </div>
                      <template v-else> <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div> </template>
                    </div>
                    <div class="d-flex gap8 align-items-center" v-if="['Activities'].includes(eachTreatment)">
                      <p class="mb-0 font12 gray900">Frequency</p>
                      <p class="mb-0 font12 fw700 gray900">{{ getFrequencyName(treatmentDetails.activity_freq) }}</p>
                    </div>
                    <div class="d-flex gap16 align-items-center">
                      <p class="mb-0 font12 gray900">Effectiveness</p>
                      <p class="mb-0 font12 fw700" :style="{ color: getTreatEffectivenessColor(treatmentDetails.effectiveness) }">{{ getTreatEffectiveness(treatmentDetails.effectiveness) }}</p>
                    </div>
                    <div class="d-flex gap16 align-items-center" v-if="!['Procedures'].includes(eachTreatment)">
                      <p class="mb-0 font12 gray900">From: {{ new Date(treatmentDetails.treatment_duration[0][0]).toDateString().substring(4) }}</p>
                      <p class="mb-0 font12 gray900">
                        To: {{ !treatmentDetails.treatment_duration[0][1] ? "Still Taking" : new Date(treatmentDetails.treatment_duration[0][1]).toDateString().substring(4) }}
                      </p>
                    </div>
                    <p v-else class="mb-0 font12 gray900">On: {{ new Date(treatmentDetails.treatment_duration[0][0]).toDateString().substring(4) }}</p>
                  </div>
                </template>
                <div class="br8 p-3 bg-gray100 text-center font16 gray400" v-else>None added</div>
              </div>
            </div>
          </div>
          <div v-else class="dailog">This user hasn’t added other diagnosed conditions yet.</div>
        </div>
      </div>

      <!-- AdditionalConditions -->

      <div id="2loop" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
        <div v-if="cardKey === 'given_what_i_know_now'" class="symptoms">
          <div v-if="!cardValue" class="cont">
            <div class="header-cont">
              <span class="header"> Additional Conditions </span>
            </div>
            <span class="bio"> (Conditions that hasn’t been diagnosed by a healthcare professional)</span>
          </div>
          <div class="top" v-if="profileData['add_conditions'].length > 0">
            <div v-for="(item, index) in additionalConditions" :key="index" class="other-condition">
              <div class="other-cond-header">
                <span v-if="item" class="header-cond">{{ item }}</span>
              </div>
              <div class="symp-cont">
                <span class="name">Symptoms:</span>
                <div v-for="(symptom, index) in profileData['add_conditions']" :key="index">
                  <div v-if="symptom.circle_name === item" class="symptomsgrid">
                    <div class="grid-item">
                      <div class="info-cont">
                        <span class="name"> {{ symptom.display_name }}</span>
                        <span
                          :style="{
                            color: getEffectivenessColor(symptom.effectiveness),
                            background: `${getEffectivenessColor(symptom.effectiveness)}25`,
                            padding: '2px 5px',
                            'min-width': '100px',
                            'border-radius': '5px',
                            width: 'fit-content',
                            display: 'flex',
                            'justify-content': 'center',
                          }"
                        >
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="dailog">This user hasn’t added other conditions yet.</div>
        </div>
      </div>

      <!-- All other conditions -->

      <!-- <div id="3loop" v-for="(cardValue ,cardKey, index) in cardKeys" :key="index"> -->

      <!-- mostdays i find most_days_i_find_myself -->

      <!-- <div v-if="cardKey === 'most_days_i_find_myself'" class="symptoms">
                    <div v-if="!cardValue" class="header-cont">
                      <span class="header">Most Days I find myself</span>
                    </div>
                    <div v-if="profileData['most_days_i_find_myself']" class="textcontainer">
                      {{ profileData["most_days_i_find_myself"] }}
                    </div>
                    <div v-else class="dailog">User haven’t responded yet.</div>
                    </div> -->

      <!-- my life has changed  -->

      <!-- <div v-if="cardKey === 'My life has changed in this way'" class="symptoms">
              <div v-if="!cardValue" class="header-cont">
                <span class="header">My life has changed in this way</span>
              </div>
              <div v-if="profileData['most_days_i_find_myself']" class="textcontainer">
                {{ profileData["my_life_has_changed_in_this_way"] }}
              </div>
              <div v-else class="dailog">User haven’t responded yet.</div>
            </div> -->

      <!-- when iam having bad day -->

      <!-- <div v-if="cardKey === 'when_im_having_a_bad_day'" class="symptoms">
              <div v-if="!cardValue" class="header-cont">
                <span class="header">when Iam Having a Bad Day</span>
              </div>
              <div v-if="profileData['when_im_having_a_bad_day']" class="textcontainer">
                {{ profileData["when_im_having_a_bad_day"] }}
              </div>
              <div v-else class="dailog">User haven’t responded yet.</div>
            </div> -->

      <!--  given_what_i_know_now -->

      <!-- <div v-if="cardKey === 'given_what_i_know_now'" class="symptoms">
              <div v-if="!cardValue" class="header-cont">
                <span class="header">Given what I know now</span>
              </div>
              <div v-if="profileData['given_what_i_know_now']" class="textcontainer">
                {{ profileData["given_what_i_know_now"] }}
              </div>
              <div v-else class="dailog">User haven’t responded yet.</div>
            </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import moment from "moment"
import { groupBy } from "lodash"
import SimpleLoader from "../../../commons/SimpleLoader.vue"

const UserRepository = RepositoryFactory.get("user")
export default {
  name: "PatientAbout",
  props: {
    // cardKeys: Array,
    // profileData: Object
  },
  components: { SimpleLoader },
  data() {
    return {
      cardKeys: null,
      profileData: null,
      editableData: null,
      groupedTreatments: null,
      toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "story", "diagnosis_date", "user_circle", "about"],
      // test: null
      status: false,
      otherPatientConditions: [],
      additionalConditions: [],
      otherConditionsList: [],
      otherCondnLoading: false,
      treatmentTypes: ["Medications", "Procedures", "Activities", "Nutrition", "Complimentary Therapy"],
    }
  },
  created() {
    console.warn("ViewPatientAbout.vue created")
    console.log("profileData:", this.profileData)
    this.fetchData()
    this.fetchOtherCondns()
  },
  computed: {
    getDOB() {
      if (this.profileData["dob"] != null) {
        return moment(this.profileData["dob"], "yyyymmdd")
          .fromNow()
          .split(" ")[0]
      } else {
        return " "
      }
    },
    getDiagnosisDate() {
      // let pDate = moment(this.profileData["diagnosis_date"], "yyyymmdd")
      //   .fromNow(true)
      //   .split(" ")[0]
      // console.log("time:", moment(this.profileData["diagnosis_date"], "yyyymmdd").fromNow(true))
      // console.log({ pDate })
      // if (pDate === "a") {
      //   return "1 year"
      // } else {
      //   return `${pDate} years`
      // }
      return moment(this.profileData["diagnosis_date"], "yyyymmdd").fromNow(true)
    },
    getDiagnosedYear() {
      return new Date(this.profileData["diagnosis_date"]).getFullYear()
    },
  },
  watch: {
    "profileData.other_symptom": function(newVal, oldVal) {
      let otherConditions = new Set()
      if (newVal) {
        newVal.map(ele => otherConditions.add(ele.circle_name))
      }
      otherConditions.forEach(ele => this.otherPatientConditions.push(ele))
    },
    "profileData.add_conditions": function(newVal, oldVal) {
      let additionalCond = new Set()
      if (newVal !== oldVal) {
        newVal.map(ele => additionalCond.add(ele.circle_name))
        // additionalCond.forEach(ele => this.otherPatientConditions.push(ele));
        this.additionalConditions = Array.from(additionalCond)
        this.additionalConditions.slice(0, newVal.length)
      }
    },
  },
  methods: {
    getTreamentDisplayName(type, value) {
      switch (type.toLowerCase()) {
        case "medications":
          return value.medication_details.display_name || "Medication"
        case "procedures":
          return value.procedure_details.display_name || "Procedure"
        case "activities":
          return value.activity_details.display_name || "Activity"
        case "nutrition":
          return value.nutrition_details.display_name || "Nutrition"
        case "complimentary therapy":
          return value.complimentary_details.display_name || "Complimentary Therapy"
        default:
          return ""
      }
    },
    getOCKeyName(name) {
      switch (name.toLowerCase()) {
        case "medications":
          return "medication"
        case "procedures":
          return "procedure"
        case "activities":
          return "activity"
        case "nutrition":
          return "nutrition"
        case "complimentary therapy":
          return "complimentary"
        default:
          return ""
      }
    },
    fetchOtherCondns() {
      this.otherCondnLoading = true
      UserRepository.getOtherConditions(this.viewUser.id, this.currentCircle.id, this.viewUser.role)
        .then(otherCondn => {
          this.otherConditionsList = otherCondn.data.data
          this.otherCondnLoading = false
        })
        .catch(e => {
          this.otherCondnLoading = false
        })
    },
    handleGoToConditions() {
      document.getElementById("other_conditions").scrollIntoView()
    },
    /**
     * Fetch user profile data
     */
    async fetchData() {
      const data = await UserRepository.getAbout(this.viewUser, this.currentCircle.id)
      this.profileData = data.data.data ? data.data.data[0] : {}
      let profileDataCopy = { ...this.profileData }
      this.toDeleteKeys.forEach(key => {
        delete profileDataCopy[key]
      })
      // const keys = Object.keys(profileDataCopy)
      const keys = Object.keys(profileDataCopy)
      this.cardKeys = this.makeKeys(keys)
      const patientTreatmentsList = this.profileData.treatment.map(ele => {
        ele.treatment[0].display_name = ele.treatment[0].display_name.toLowerCase()
        return ele
      })
      this.groupedTreatments = this.makeTreatments(patientTreatmentsList)
      this.status = true
    },
    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },
    makeTreatments(treatments) {
      const groupedTreatments = groupBy(treatments, function(treatment) {
        return treatment.treatment_type
      })
      return groupedTreatments
    },
    makeEditable(cardKey) {
      this.keys[cardKey] = true
      this.editableData = this.data[cardKey]
    },
    cancelEditable(cardKey) {
      this.keys[cardKey] = false
      this.data[cardKey] = this.editableData
      this.editableData = null
    },
    getEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "0":
        case 0:
          return "Mild"
        case "50":
        case 50:
          return "Moderate"
        case "100":
        case 100:
          return "Severe"
        default:
          break
      }
    },
    getEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "0":
        case 0:
          return "#14DE0D"
        case "50":
        case 50:
          return "#F6B156"
        case "100":
        case 100:
          return "#FF4400"
        default:
          break
      }
    },
    getTreatEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "100":
        case 100:
          return "#14DE0D"
        case "50":
        case 50:
          return "#F6B156"
        case "0":
        case 0:
          return "#FF4400"
        default:
          break
      }
    },
    getTreatEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "100":
        case 100:
          return "Very Effective"
        case "50":
        case 50:
          return "Somewhat Effective"
        case "0":
        case 0:
          return "Not Effective"
        default:
          break
      }
    },
    save(cardKey) {
      this.editableData = null
      this.keys[cardKey] = false
    },
  },
  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },
    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
//new csss

.grid-cont {
  display: flex;
  // width: 757px;
  gap: 16px;
}

.textcontainer {
  // word-break: break-all;
  word-wrap: break-word;
  width: 789px;
  // height: 128px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  // white-space: pre-line;
  white-space: pre-wrap;
  @media screen and (max-width: 700px) {
    width: 100%;
    height: inherit;
  }
}

.symp-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  // width: 757px;
  min-height: 122px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  height: 22px;
  background: #ffd7cc;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #ea3100;
}

.other-symp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 757px;
  height: 122px;
}
.btns {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 24px;
  width: 470px;
  height: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
    display: none;
  }
}
.btns-mob {
  display: none;
  @media screen and (max-width: 700px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0px;
    gap: 24px;
    width: 100%;
    height: 24px;
  }
}

.header-cond {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  width: 100%;
}

.other-cond-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  height: 30px;
  @media screen and (max-width: 700px) {
    height: inherit;
    width: 100%;
  }
}

.other-condition {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  // width: 789px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
  // width: 719px;
  height: 70px;
  @media screen and (max-width: 700px) {
    height: inherit;
  }
}

.dlt-inner {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #ea3100;
}
.dlt {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 228.5px;
  height: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #ea3100;
}

.grid-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 48px;
  width: 369.5px;
  min-width: 311px;
  min-height: 82px;
  max-height: 106px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-width: 311px;
  }
}

.symptomsgrid {
  // display: grid;
  // grid-template-columns: 1fr ;
  // padding: 0px;
  // // width: 789px;
  // // height: 180px;
  // grid-row-gap: 16px;
  // grid-column-gap: 16px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 16px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.symptoms {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  // width: 789px;
  margin-bottom: 80px;
}

.stry-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  // gap: 80px;
  width: 100%;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.whitespace {
  white-space: pre-line;
}

.bio {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
  // white-space: pre-line;
  // white-space: pre-wrap; // commented to fix extra space at beginning
  word-wrap: break-word;
  width: 100%;
}
.minibio {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // white-space: pre-line;
  // white-space: pre-wrap;
  // width: 790px;
  // height: 160px;
}

.dailog {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  min-width: 790px;
  width: 100%;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-width: 0px;
    text-align: center;
    height: inherit;
  }
}

.dailog1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  width: 100%;
}
.interest {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // width: 790px;
  // height: 88px;
}

.intrst {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;
  width: fit-content;
  background: #f1f5f9;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #1e2945;
}
.intrst-cont {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.info-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
}

.general-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  // width: 790px;
  width: 100%;
  height: 56px;
  @media screen and (max-width: 700px) {
    width: 100%;
    height: inherit;
    flex-direction: column;
    height: inherit;
    gap: 24px;
    align-items: normal;
  }
}

.abt-2-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 48px;
  width: 100%;
  height: inherit;
  margin-bottom: 80px;
  margin-top: 16px;
  @media screen and (max-width: 700px) {
    height: inherit;
    margin-bottom: 80px;
  }
}

.intro {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  width: 100%;
  // text-transform: capitalize;
}

.name {
  font-weight: 700;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.edit-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 4px;
  // gap: 10px;
  width: 80px;
  height: 32px;
  border-radius: 8px;
}

.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}

.top {
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.abt-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  // gap: 24px;
  width: 100%;
  // height: 538px;
  @media screen and (max-width: 700px) {
    height: inherit;
  }
}

.header-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  // min-height: 5px;
  // margin-bottom: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-height: 0px;
    margin-bottom: 0px;
  }
}

.header {
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}

////old css
.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 80px;

  .title {
    font-size: 18px;
    font-weight: bold;
    @media screen and (max-width: 900px) {
      max-width: 85%;
      min-width: 85%;
    }
  }
  ul {
    list-style: none; /* Remove default bullets */
    padding: 0px;
  }

  // ul li::before {
  //   content: "\2022";
  //   // color: #21CDE5;
  //   font-weight: bold;
  //   display: inline-block;
  //   width: 10px;
  //   height: 10px;
  //   margin-left: -1em;
  //   padding-right: 15px;
  // }

  .language {
    display: flex;
    margin-left: 20px;
    justify-content: space-between;
  }

  .mono-language {
    display: flex;
  }
}
.display-symptom {
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(37, 103, 237, 0.05);
  border-radius: 5px;
  font-size: 14px;
}
.treatment-eff {
  @media screen and (max-width: 1200px) {
    font-size: 10px;
  }
}
.profile-sub {
  span::after {
    content: ",";
  }
  span:last-child::after {
    content: "";
  }
}
</style>

<!-- <style lang="scss" scoped>
//new csss

.grid-cont{
  display: flex;
  width: 757px;
  gap:16px;
}

.textcontainer{
  width: 789px;
  height: 128px;
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 32px;
color: #647490;
@media screen and (max-width:700px) {
  width: 100%;
  height: inherit;
}
}

.symp-cont{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 16px;
width: 757px;
min-height: 122px;
@media screen and (max-width:700px) {
  width: 100%;
}
}

.tag{
  display: flex;
flex-direction: row;
align-items: flex-start;
padding: 4px 8px;
height: 22px;
background: #FFD7CC;
border-radius: 4px;
font-weight: 700;
font-size: 12px;
line-height: 14px;
text-align: center;
color: #EA3100;
}

.other-symp{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 16px;

width: 757px;
height: 122px;  
}
.btns{
  display: flex;
flex-direction: row;
justify-content: flex-end;
align-items: center;
padding: 0px;
gap: 24px;
width: 470px;
height: 24px;
}

.header-cond{
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0F1734;
  width: 100%;
}

.other-cond-header{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  height: 30px;
  @media screen and (max-width:700px) {
 height: inherit;
 width: 100%;
}
}


.other-condition{
 box-sizing: border-box;
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 16px;
gap: 16px;
// width: 789px;
background: #FFFFFF;
border: 1px solid #E2E8F0;
border-radius: 8px;
margin-bottom: 24px;
@media screen and (max-width:700px) {
  width: 100%;
}
}


.cont{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 4px;
width: 100%;
// width: 719px;
height: 70px;
@media screen and (max-width:700px) {
  height: inherit;
}
}

.dlt-inner{
  cursor: pointer;
  display: flex;
flex-direction: row;
align-items: center;
padding: 0px;
gap: 4px;
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 24px;
color: #EA3100;

}
.dlt{
  cursor: pointer;
  display: flex;
flex-direction: row;
justify-content: flex-end;
align-items: center;
padding: 0px;
gap: 4px;
width: 228.5px;
height: 24px;
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 24px;
color: #EA3100;

}

.grid-item{
  display: flex;
flex-direction: row;
align-items: center;
padding: 16px;
gap: 48px;
width: 369.5px;
min-height: 82px;
max-height: 106px;
background: #FFFFFF;
border: 1px solid #E2E8F0;
border-radius: 8px;
}

.symptomsgrid{
// display: grid;
// grid-template-columns: 1fr ;
// padding: 0px;
// // width: 789px;
// // height: 180px;
// grid-row-gap: 16px;
// grid-column-gap: 16px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 16px;
    column-gap: 16px;
    @media screen and (max-width:700px) {
  width:100%;
  
}
}


.symptoms{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 24px;
width: 789px;
margin-bottom: 80px;
}

.stry-cont{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
// gap: 80px;
@media screen and (max-width:700px) {
  width: 100%;
}
}

.bio{
  font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 32px;
color: #647490;
}
.minibio{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 8px;

width: 790px;
// height: 160px;
}

.dailog{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  min-width: 790px;
  height: 56px;
  background: #F1F5F9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94A3B8;
  @media screen and (max-width:700px) {
  width: 100%;
  min-width: 0px;
  text-align: center;
  height: inherit;
}
}



.dailog1{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #F1F5F9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94A3B8;
}
.interest{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 8px;

width: 790px;
height: 88px;
}


.vertical-seperator{
  width: 1px;
  height: 36px;
  background: #CBD5E1;
  @media screen and (max-width:700px) {
    display: none;
  }
}

.info-cont{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 8px;
}

.general-info{
  display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
padding: 0px;
// width: 790px;
width: 100%;
height: 56px;
@media screen and (max-width:700px) {
  width: 100%;
  height: inherit;
  flex-direction: column;
  height: inherit;
  gap:24px;
  align-items: normal;
}
}

.abt-2-cont{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 48px;
width: 100%;
// width: 790px;
// height: 472px;
@media screen and (max-width:700px) {
  height: inherit;
  margin-bottom: 80px;
}
}

.intro{
  font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #000000;
}

.name{
font-weight: 700;
@media screen and (max-width:700px) {
  width: 100%;
}
}


.top{
  @media screen and (max-width:700px) {
  width: 100%;
}
}

.edit-button{
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 10px;
  width: 80px;
  height: 32px;
  border-radius: 8px;
}

.button-text{
  font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 24px;
cursor: pointer;
}

.abt-container{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
// gap: 24px;
width:100%;
height: 538px;
@media screen and (max-width:700px) {
  height: inherit;
}
}



.header-cont{
  display: flex;
flex-direction: row;
align-items: center;
padding: 0px;
gap: 16px;
min-height: 5px;
margin-bottom: 24px;
@media screen and (max-width:700px) {
  width: 100%;
  min-height: 0px;
  margin-bottom: 0px;
}
}

.header{
  font-style: normal;
font-weight: 700;
font-size: 32px;
line-height: 42px;
color: #0F1734;
}




////old css
.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 80px;

  .title {
    font-size: 18px;
    font-weight: bold;
    @media screen and (max-width: 900px) {
      max-width: 85%;
      min-width: 85%;
    }
  }
  ul {
    list-style: none; /* Remove default bullets */
    padding: 0px;
  }

  // ul li::before {
  //   content: "\2022";
  //   // color: #21CDE5;
  //   font-weight: bold;
  //   display: inline-block;
  //   width: 10px;
  //   height: 10px;
  //   margin-left: -1em;
  //   padding-right: 15px;
  // }

  .language {
    display: flex;
    margin-left: 20px;
    justify-content: space-between;
  }

  .mono-language {
    display: flex;
  }
}
.display-symptom {
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(37, 103, 237, 0.05);
  border-radius: 5px;
  font-size: 14px;
}
.treatment-eff {
  @media screen and (max-width: 1200px) {
    font-size: 10px;
  }
}
.profile-sub {
  span::after {
    content: ",";
  }
  span:last-child::after {
    content: "";
  }
}
</style> -->



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientAbout.vue